// extracted by mini-css-extract-plugin
export default {"metrics":"src-modules-account-institution-metrics-style__metrics_uVlri","breakdownChartWrapper":"src-modules-account-institution-metrics-style__breakdownChartWrapper_SpVYl"};